import BtcLogo from "../../img/btc.png";
// import ethLogo from "../../img/eth.png";
// import ltcLogo from "../../img/ltc.png";
import usdtLogo from "../../img/usdt.png";
// import bnbLogo from "../../img/bnb.png";
// import dogeLogo from "../../img/doge.png";
// import tronLogo from "../../img/tron.png";
// import shibaLogo from "../../img/shiba.png";
// import btccLogo from "../../img/btcc.png";

export const wallets = [
  {
    coin: "Bitcoin",
    address: "1GLMfL1aC7jc6yHe5UZ94wHmdJcDbhrGuK",
    addressName: "BTC Address",
    icon: BtcLogo,
  },
  // {
  //   coin: "ETH ",
  //   address: "0x9a5235891E9B696c84ec45fC65486A23B501ff6f",
  //   addressName: "ETH Address:",
  //   icon: ethLogo,
  // },
  // {
  //   coin: "Litecoin",
  //   address: "MPp8dz1oMUsr641GjFNeKNCEJJGQnBoZ3p",
  //   addressName: "LTC Address",
  //   icon: ltcLogo,
  // },
  {
    coin: "USDT TRC20",
    address: "TNBZchiy7aAKQ58n7fWLmP61hvJ8JQ1mTj",
    addressName: "USDT TRC20 Address",
    icon: usdtLogo,
  },
  // {
  //   coin: "BNB",
  //   address: "bnb1elx3at8cs5f3gmsv0m099aezw2537grhp0wq8v",
  //   addressName: "BNB Address",
  //   icon: bnbLogo,
  // },
  // {
  //   coin: "DOGE ",
  //   address: "DCaesiayioshxstDwW92ocFChwshjYGm8X",
  //   addressName: "Dogecoin Address",
  //   icon: dogeLogo,
  // },
  // {
  //   coin: "TRON ",
  //   address: "TVdAzHK24oAa92FcGReEexRa59v4KCquwP",
  //   addressName: "TRON Address",
  //   icon: tronLogo,
  // },
  // {
  //   coin: "SHIBA",
  //   address: "0xef8Ea6d059dDD47AaD4F7A5F190352688600d554",
  //   addressName: "SHIBA Address",
  //   icon: shibaLogo,
  // },
  // {
  //   coin: "BITCOIN CASH",
  //   address: "qrpx7wgv37qpaf3jealnrylg5kg37htv2yw326mymn",
  //   addressName: "BCH Address",
  //   icon: btccLogo,
  // },
];
